// extracted by mini-css-extract-plugin
module.exports = {"avatar":"dialog-group-offline_avatar_1VNtO"};